import {
  arrayBuilderItemSubsequentPageTitleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SchoolEnrollmentProofDescription from '../../components/FormDescriptions/SchoolEnrollmentProofDescription';
import { attachmentSchema, attachmentUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['applicants--school-enrollment-proof-title'];

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(TITLE_TEXT),
    ...descriptionUI(SchoolEnrollmentProofDescription),
    applicantSchoolCert: attachmentUI({
      title: TITLE_TEXT,
      attachmentId: ATTACHMENT_IDS.schoolCertificationForm,
    }),
  },
  schema: {
    type: 'object',
    required: ['applicantSchoolCert'],
    properties: {
      applicantSchoolCert: attachmentSchema,
    },
  },
};
